
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  'use strict';
const $09e991522ca7e64e$var$CLASSNAME = Object.freeze({
    Start: 'start',
    Restart: 'restart',
    Hidden: 'hidden',
    ActionButton: 'button'
});
const $09e991522ca7e64e$var$LABEL = Object.freeze({
    Start: 'Start',
    Restart: 'Restart'
});
var $a5fd07fa01589658$exports = {};
'use strict';
// required for jest to work correctly
$parcel$global.structuredClone = (val)=>JSON.parse(JSON.stringify(val));
class $a5fd07fa01589658$var$Game {
    /**
   * Default number of starting tiles.
   * @readonly
   * @const
   * @type {number}
   */ static START_TILES_QUANTITY_DEFAULT = 2;
    /**
   * The default board configuration (a 4x4 grid of zeros).
   * @readonly
   * @const
   * @type {number[][]}
   */ static DEFAULT_BOARD = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    /**
   * List of keys that represent movement directions.
   * @readonly
   * @const
   * @type {Array<string>}
   */ static MOVE_KEYS = Object.freeze([
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown'
    ]);
    /**
   * Enum for the status of the game.
   * - `Idle`: The game has not started and is idling.
   * - `Playing`: The game has started and is in progress.
   * - `Lost`: The game has finished and the player lost.
   * - `Won`: The game has finished and the player won.
   *
   * @readonly
   * @enum {string}
   */ static STATUS = Object.freeze({
        Idle: 'idle',
        Playing: 'playing',
        Lost: 'lose',
        Won: 'win'
    });
    /**
   * Represents current {@link Game.STATUS|status} of the game
   * @type {keyof typeof Game.STATUS}
   * @private
   * @default Game.STATUS.Idle
   */ _status = $a5fd07fa01589658$var$Game.STATUS.Idle;
    /**
   * Represents current score of the game
   * @type {number}
   * @private
   */ _score = 0;
    /**
   * Represents the current state (grid) of the game.
   *
   * The grid is stored as a 2D array where each element represents a tile.
   * Empty tiles are represented by `0`, while others contain powers of two.
   *
   * @type {number[][]}
   * @private
   */ _state;
    /**
   * Creates a new game instance.
   *
   * This constructor initializes the game with a given board state and the
   * number of tiles to be placed at the start. It also allows for sanitizing
   * the state (if necessary) to ensure that only valid values are used on the
   * board.
   *
   * @param {Object} options - The configuration options for the game instance.
   * @param {number[][]} [options.initialState=null] - The initial state of
   *   the board.
   *
   * If provided, the board will be initialized with the passed array, which
   * must adhere to the 2D grid format. The values in the grid must either be
   * `0` (empty space) or a power of 2 (e.g., 2, 4, 8, etc.). If no
   * `initialState` is provided, the game will use the
   * {@link DEFAULT_BOARD|default grid}.
   *   @default
   *   [
   *     [0, 0, 0, 0],
   *     [0, 0, 0, 0],
   *     [0, 0, 0, 0],
   *     [0, 0, 0, 0]
   *   ]
   *
   * @param {number} [options.startTilesAmount=2] - The initial number of
   *   random tiles to be placed on the board at the start of the game. This
   *   is the number of tiles with values `2` or `4` that will be randomly
   *   placed on the grid when the game begins. The tiles are placed randomly
   *   in empty spots (values of `0`). If not provided,
   * {@link START_TILES_QUANTITY_DEFAULT|default value} will be used.
   *   @default 2
   *
   * @param {boolean} [options.forcePowerOfTwo=false] - Flag to determine
   *   whether the grid values should be sanitized to ensure they are all
   *   powers of two.
   *   - If `true`, all values that are not powers of 2 will be adjusted to
   *     the nearest lower power of 2 or set to `0`.
   *   - If `false`, invalid values will be set to `0`.
   *   @default false
   */ constructor({ initialState: initialState = null, startTilesAmount: startTilesAmount = $a5fd07fa01589658$var$Game.START_TILES_QUANTITY_DEFAULT, forcePowerOfTwo: forcePowerOfTwo = false } = {}){
        const init = $a5fd07fa01589658$var$Game.sanitizeState(initialState || structuredClone($a5fd07fa01589658$var$Game.DEFAULT_BOARD), forcePowerOfTwo);
        this._state = init;
        this.initialState = structuredClone(init);
        this.startTilesAmount = startTilesAmount;
    }
    /**
   * Starts the game, setting:
   * - the {@link Game._status|status} to {@link Game.STATUS.Playing|`playing`}
   *
   * Places new tiles on the board. The number of tiles placed at the start is
   * determined by the `startTilesAmount` property.
   */ start() {
        this._status = $a5fd07fa01589658$var$Game.STATUS.Playing;
        for(let i = 0; i < this.startTilesAmount; i++)this.placeNewTile();
    }
    /**
   * Restarts the game, resetting:
   * - the {@link Game._score|score} to `0`,
   * - the {@link Game._state|state} to {@link DEFAULT_BOARD|default}
   * - the {@link Game._status|status} to {@link Game.STATUS.Idle|`Idle`}
   */ restart() {
        this._state = structuredClone(this.initialState);
        this._status = $a5fd07fa01589658$var$Game.STATUS.Idle;
        this._score = 0;
    // this.start();
    }
    // #region get (something)
    /**
   * Utility getter, used to get current board size (n*n)
   * @returns {number}
   */ get size() {
        return this._state.length;
    }
    /**
   * Returns {@link Game._score|current score} of the game
   * @returns {number}
   */ getScore() {
        return this._score;
    }
    /**
   * Returns {@link Game._state|current state} (grid) of the game
   * @returns {number[][]}
   */ getState() {
        return this._state;
    }
    /**
   * Returns {@link Game._status|current status} of the game
   * @returns {string}
   */ getStatus() {
        return this._status;
    }
    // #endregion
    // #region move handlers
    move(key) {
        if (this._status !== $a5fd07fa01589658$var$Game.STATUS.Playing) return;
        switch(key){
            case 'ArrowUp':
                this.moveUp();
                break;
            case 'ArrowRight':
                this.moveRight();
                break;
            case 'ArrowDown':
                this.moveDown();
                break;
            case 'ArrowLeft':
                this.moveLeft();
                break;
        }
    }
    handleMove() {
        if (this._status !== $a5fd07fa01589658$var$Game.STATUS.Playing) return;
        const prevState = structuredClone(this._state);
        for(let col = 0; col < this.size; col++){
            const numbers = [];
            for(let row = 0; row < this.size; row++)if (this._state[row][col] !== 0) numbers.push(this._state[row][col]);
            const merged = [];
            let i = 0;
            while(i < numbers.length)if (i + 1 < numbers.length && numbers[i] === numbers[i + 1]) {
                const stackedNumber = numbers[i] * 2;
                merged.push(stackedNumber);
                this._score += stackedNumber;
                i += 2;
            } else {
                merged.push(numbers[i]);
                i++;
            }
            while(merged.length < this.size)merged.push(0);
            for(let row = 0; row < this.size; row++)this._state[row][col] = merged[row];
        }
        const hasChanged = this._state.some((row, rowIndex)=>row.some((cell, colIndex)=>cell !== prevState[rowIndex][colIndex]));
        if (hasChanged) this.placeNewTile();
        this.updateGameStatus();
    }
    /**
   * Handles the `ArrowUp` keypress
   */ moveUp() {
        this.handleMove();
    }
    /**
   * Handles the `ArrowUp` keypress, rotating the grid 180°,
   * applying the handler and rotating the grid back
   */ moveDown() {
        this.reverseGrid();
        this.handleMove();
        this.reverseGrid();
    }
    /**
   * Handles the `ArrowLeft` keypress
   * and performing the same action as {@link Game.moveDown|moveDown()}, by
   * rotating the matrix by 90° clockwise
   */ moveLeft() {
        this.rotateClockwise();
        this.handleMove();
        this.rotateCounterClockwise();
    }
    /**
   * Handles the `ArrowRight` keypress
   * and performing the same action as {@link Game.moveDown|moveDown()}, by
   * rotating the matrix by 90° counterclockwise
   */ moveRight() {
        this.rotateCounterClockwise();
        this.handleMove();
        this.rotateClockwise();
    }
    /**
   * Reverses the order of rows in the grid.
   *
   * Used as a helper method in grid rotation.
   */ reverseGrid() {
        this._state.reverse();
    }
    /**
   * Transposes the grid by swapping rows and columns.
   *
   * This method is used for rotating the grid by converting rows into columns.
   */ transpose() {
        for(let i = 0; i < this.size; i++)for(let j = i + 1; j < this.size; j++)[this._state[i][j], this._state[j][i]] = [
            this._state[j][i],
            this._state[i][j]
        ];
    }
    /**
   * Rotates the grid 90° clockwise.
   *
   * This is done by {@link Game.transpose|transposing}
   * the grid and then {@link Game.reverseGrid|reversing} each row.
   */ rotateClockwise() {
        this.transpose();
        this._state.forEach((row)=>row.reverse());
    }
    /**
   * Rotates the grid 90° counterclockwise.
   *
   * This is done by {@link Game.transpose|transposing}
   * the grid and then {@link Game.reverseGrid|reversing} each row.
   */ rotateCounterClockwise() {
        this._state.forEach((row)=>row.reverse());
        this.transpose();
    }
    // #endregion
    /**
   * Updates the game status based on the current game state.
   *
   * - If no move is possible, the {@link Game._status|game status}
   *  is set to `Lost`.
   * - If the board contains the number 2048, the game status is set to `Won`.
   *
   * @returns {void}
   */ updateGameStatus() {
        if (!this.checkMovePossibility()) {
            this._status = $a5fd07fa01589658$var$Game.STATUS.Lost;
            return;
        }
        const hasWon = this._state.some((row)=>row.includes(2048));
        if (hasWon) this._status = $a5fd07fa01589658$var$Game.STATUS.Won;
    }
    // #region utility
    /**
   * Sanitizes the game state by ensuring that all values are either 0 or
   * a power of two. Optionally, forces values to the nearest lower power
   * of two.
   *
   * - If `forcePowerOfTwo` is `true`, each value will be replaced with the
   * nearest lower power of two.
   * - If `forcePowerOfTwo` is `false`, only values that are already powers
   * of two are kept, and others are set to 0.
   *
   * @param {number[][]} state - The 2D array representing the initial state
   * of the game board passed as parameter to a constructor.
   * @param {boolean} [forcePowerOfTwo=false] - Whether to force each value
   * to be the nearest lower power of two. Defaults to `false`.
   * @returns {number[][]} A sanitized 2D array with all values being either
   * 0 or a power of two.
   */ static sanitizeState(state, forcePowerOfTwo = false) {
        const isPowerOfTwo = (n)=>n > 0 && (n & n - 1) === 0;
        const getNearestLowerPowerOfTwo = (n)=>{
            if (n <= 0) return 0;
            return Math.pow(2, Math.floor(Math.log2(n)));
        };
        const sanitizeValue = (val)=>{
            if (forcePowerOfTwo) return getNearestLowerPowerOfTwo(val);
            return isPowerOfTwo(val) ? val : 0;
        };
        return state.map((row)=>row.map(sanitizeValue));
    }
    /**
   * Returns a random value, either 2 or 4, with a 90% chance of getting 2.
   *
   * @returns {number} 2 or 4, depending on the random chance.
   */ getTwoOrFour() {
        return Math.random() < 0.9 ? 2 : 4;
    }
    /**
   * Places a new tile (either 2 or 4) in a random empty cell on the game board.
   * The tile is placed in a cell where the current value is 0.
   * If there are no empty cells, no tile is placed.
   */ placeNewTile() {
        const emptyCells = [];
        for(let row = 0; row < this.size; row++){
            for(let col = 0; col < this.size; col++)if (this._state[row][col] === 0) emptyCells.push({
                row: row,
                col: col
            });
        }
        if (emptyCells.length > 0) {
            const randomCellIndex = Math.floor(Math.random() * emptyCells.length);
            const { row: row, col: col } = emptyCells[randomCellIndex];
            this._state[row][col] = this.getTwoOrFour();
        }
    }
    /**
   * Checks whether a move is possible in the current game state.
   *
   * A move is possible if:
   * - There is at least one empty cell (value of 0).
   * - Or if there are two adjacent cells (horizontally or vertically)
   * with the same value.
   *
   * @returns {boolean} `true` if a move is possible, otherwise `false`.
   */ checkMovePossibility() {
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++){
            const cell = this._state[row][col];
            if (!cell) return true;
            if (col < this.size - 1 && this._state[row][col + 1] === cell) return true;
            if (row < this.size - 1 && this._state[row + 1][col] === cell) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


// initialize the game with parameters:
/**
 * const game = new Game({
      startTilesAmount: 5,
      initialState: [
        [0, 0, 0, 0],
        [0, 4, 0, 0],
        [0, 0, 9, 0],
        [0, 0, 0, 2],
      ],
      forcePowerOfTwo: true,
});
 */ const $09e991522ca7e64e$var$initialState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports({
    initialState: $09e991522ca7e64e$var$initialState
});
const $09e991522ca7e64e$var$gameContainer = document.querySelector('.container');
const $09e991522ca7e64e$var$actionButton = $09e991522ca7e64e$var$gameContainer.querySelector('.controls button');
const $09e991522ca7e64e$var$scoreInfo = $09e991522ca7e64e$var$gameContainer.querySelector('.controls .info');
const $09e991522ca7e64e$var$scoreNumberField = $09e991522ca7e64e$var$gameContainer.querySelector('.controls .game-score');
const $09e991522ca7e64e$var$gameGrid = $09e991522ca7e64e$var$gameContainer.querySelector('.game-field tbody');
const $09e991522ca7e64e$var$messageStart = $09e991522ca7e64e$var$gameContainer.querySelector('.message-start');
const $09e991522ca7e64e$var$messageWin = $09e991522ca7e64e$var$gameContainer.querySelector('.message-win');
const $09e991522ca7e64e$var$messageLose = $09e991522ca7e64e$var$gameContainer.querySelector('.message-lose');
function $09e991522ca7e64e$var$renderGame() {
    $09e991522ca7e64e$var$updateScoreDisplay();
    $09e991522ca7e64e$var$updateGameBoard();
    $09e991522ca7e64e$var$updateGameStatusMessage();
}
function $09e991522ca7e64e$var$updateScoreDisplay() {
    $09e991522ca7e64e$var$scoreNumberField.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateGameStatusMessage() {
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    const isGameIdle = gameStatus === $a5fd07fa01589658$exports.STATUS.Idle;
    $09e991522ca7e64e$var$messageStart.classList.add($09e991522ca7e64e$var$CLASSNAME.Hidden);
    $09e991522ca7e64e$var$messageWin.classList.add($09e991522ca7e64e$var$CLASSNAME.Hidden);
    $09e991522ca7e64e$var$messageLose.classList.add($09e991522ca7e64e$var$CLASSNAME.Hidden);
    $09e991522ca7e64e$var$actionButton.classList.remove($09e991522ca7e64e$var$CLASSNAME.Restart, $09e991522ca7e64e$var$CLASSNAME.Start);
    $09e991522ca7e64e$var$actionButton.classList.add(isGameIdle ? $09e991522ca7e64e$var$CLASSNAME.Start : $09e991522ca7e64e$var$CLASSNAME.Restart);
    $09e991522ca7e64e$var$actionButton.textContent = isGameIdle ? $09e991522ca7e64e$var$LABEL.Start : $09e991522ca7e64e$var$LABEL.Restart;
    switch(gameStatus){
        case $a5fd07fa01589658$exports.STATUS.Idle:
            $09e991522ca7e64e$var$messageStart.classList.remove($09e991522ca7e64e$var$CLASSNAME.Hidden);
            break;
        case $a5fd07fa01589658$exports.STATUS.Won:
            $09e991522ca7e64e$var$messageWin.classList.remove($09e991522ca7e64e$var$CLASSNAME.Hidden);
            break;
        case $a5fd07fa01589658$exports.STATUS.Lost:
            $09e991522ca7e64e$var$messageLose.classList.remove($09e991522ca7e64e$var$CLASSNAME.Hidden);
            break;
    }
}
function $09e991522ca7e64e$var$updateGameBoard() {
    const grid = $09e991522ca7e64e$var$game.getState();
    const numRows = $09e991522ca7e64e$var$gameGrid.rows.length;
    const numCols = $09e991522ca7e64e$var$gameGrid.rows[0].cells.length;
    for(let rowIndex = 0; rowIndex < numRows; rowIndex++)for(let colIndex = 0; colIndex < numCols; colIndex++){
        const cell = $09e991522ca7e64e$var$gameGrid.rows[rowIndex].cells[colIndex];
        const value = grid[rowIndex][colIndex];
        cell.textContent = value || '';
        cell.className = `field-cell ${value ? `field-cell--${value}` : ''}`;
    }
}
document.addEventListener('keydown', (ev)=>{
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    const validKeyPressed = $a5fd07fa01589658$exports.MOVE_KEYS.includes(ev.key);
    if (!validKeyPressed) return;
    ev.preventDefault();
    if (gameStatus === $a5fd07fa01589658$exports.STATUS.Playing) {
        $09e991522ca7e64e$var$game.move(ev.key);
        $09e991522ca7e64e$var$renderGame();
    }
});
$09e991522ca7e64e$var$actionButton.addEventListener('click', ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === $a5fd07fa01589658$exports.STATUS.Idle) $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$renderGame();
});
$09e991522ca7e64e$var$scoreInfo.addEventListener('click', ()=>{
    // eslint-disable-next-line no-console
    console.log($09e991522ca7e64e$var$game.getState());
});
$09e991522ca7e64e$var$renderGame();


//# sourceMappingURL=2048.a43acabe.js.map
